<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="350px"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <div class="flex flex-col" style="padding: 20px;">
        <div class="flex card-contents">{{ contents }}</div>
        <div class="flex-footer">
          <button class="btnPrimary" @click="agree">동의</button>
          <button class="noIconButton" @click="closeDialog">미동의</button>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  components: {},
  props: ['dialog', 'agree', 'closeDialog', 'contents'],
  data () {
    return {};
  },
  watch: {
    dialog: {
      handler (val) {
        this.loading = true;
        this.init();
      },
    },
  },
  methods: {
    async init () {
      this.searchText = '';
      this.error = null;
      await this.$http
        .get('/api/v1/users/personal-address', {
          params: { personal: this.$store.state.user.email },
        })
        .then((response) => {
          this.personalAddress = response.data.personalAddressData;
          this.personalAddress.forEach((obj) => {
            obj['isPersonalAddr'] = true;
          });
          this.filteredPersonalAddress = Object.assign(
            [],
            this.personalAddress
          );
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.card-header {
  background: #efeefd;
  height: 50px;
  width: 100%;
}

.card-contents {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0 20px 0;
  font-size: 17px;
  font-weight: 500;
}
.flex-footer {
  display: flex;
  justify-content: center;
}
.dialog-okBtn {
  margin: 10px;
  width: 100px;
  background-color: #604af3;
  height: 48px;
  line-height: 48px;
  text-align: center;
  border-radius: 10px;
  color: white;
  font-size: 15px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/Confirm.vue